import { isMPClaim } from "../../../lib/misc";
import { docsFunctions } from "../../../lib/docs";
import CheckboxCell from "../../common/interactive/CheckboxCell";

export default function HeaderCheckBoxesPart({activeCase, classes}) {
    return <div className={`${classes.background_container} ${classes.flex_container}`}>
        <div>
            {/* documents police report == 16 procodocs police == 7  */}
            <div className={classes.row}><CheckboxCell label={'Police Report'} checked={docsFunctions.isDocumentUploaded(activeCase, 16, 7)} isDisabled={true} direction={'reverse'}/></div>
            <div className={classes.row}><CheckboxCell label={'Dec Page'} checked={docsFunctions.isDocumentUploaded(activeCase, 19, 6)} isDisabled={true} direction={'reverse'}/></div>
            <div className={classes.row}><CheckboxCell label={'MM Card'} checked={docsFunctions.isDocumentUploaded(activeCase, null, 11)} isDisabled={true} direction={'reverse'}/></div>
        </div>
        <div>
            <div className={classes.row}><CheckboxCell label={'MP Claim'} checked={isMPClaim(activeCase)} isDisabled={true} direction={'reverse'}/></div>
            <div className={classes.row}><CheckboxCell label={'Liability'} checked={docsFunctions.isDocumentUploaded(activeCase, 29, 12)} isDisabled={true} direction={'reverse'}/></div>
            <div className={classes.row}><CheckboxCell label={'Auto Card'} checked={docsFunctions.isDocumentUploaded(activeCase, 25, null)} isDisabled={true} direction={'reverse'}/></div>
        </div>
    </div>
}